import {
  USER_ROLES as SHARED_USER_ROLES,
  LEGACY_ROLES,
  normalizeRole,
  toLegacyRole,
  isAccountManagerRole,
  isSuperAdminRole,
} from '../../shared/roles.js'

export { normalizeRole, toLegacyRole }

export const USER_ROLES = {
  ...SHARED_USER_ROLES,
  /** @deprecated Prefer LEGACY_ROLES.ADMIN from shared roles */
  LEGACY_ADMIN: LEGACY_ROLES.ADMIN,
}

/** Global platform operator (not tenant-scoped). Accepts profile object or raw role. */
export const isSuperAdmin = (profileOrRole, tenantId = undefined) => {
  const role = typeof profileOrRole === 'object'
    ? profileOrRole?.role_canonical || profileOrRole?.role
    : profileOrRole
  const tid = typeof profileOrRole === 'object' ? profileOrRole?.tenant_id : tenantId
  return isSuperAdminRole(role, tid ?? null)
}

export const isAccountManager = (profileOrRole, tenantId = undefined) => {
  const role = typeof profileOrRole === 'object' ? profileOrRole?.role : profileOrRole
  const tid = typeof profileOrRole === 'object' ? profileOrRole?.tenant_id : tenantId
  return isAccountManagerRole(role, tid)
}

export const isClient = (profileOrRole, tenantId = undefined) => {
  const role = typeof profileOrRole === 'object' ? profileOrRole?.role : profileOrRole
  const tid = typeof profileOrRole === 'object' ? profileOrRole?.tenant_id : tenantId
  return normalizeRole(role, tid) === SHARED_USER_ROLES.CLIENT
}

export const isInfluencer = (profileOrRole, tenantId = undefined) => {
  const role = typeof profileOrRole === 'object' ? profileOrRole?.role : profileOrRole
  const tid = typeof profileOrRole === 'object' ? profileOrRole?.tenant_id : tenantId
  return normalizeRole(role, tid) === SHARED_USER_ROLES.INFLUENCER
}

export const getRoleDisplayLabel = (profileOrRole, tenantId = undefined) => {
  if (isSuperAdmin(profileOrRole, tenantId)) return 'Super Admin'
  if (isAccountManager(profileOrRole, tenantId)) return 'Account Manager'
  if (isClient(profileOrRole, tenantId)) return 'Client'
  if (isInfluencer(profileOrRole, tenantId)) return 'Influencer'
  return ''
}
